import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest, NEVER } from "rxjs";
import { filter, map, startWith, switchMap } from "rxjs/operators";
import { Page, PageArray } from "../../page/page-array.operator";



export function MatPageArray<T>(matPaginator: Observable<MatPaginator>): OperatorFunction<T[], T[]> {

  return switchMap(array =>
    matPaginator.pipe(
      filter(_matPaginator => _matPaginator != null),
      switchMap(_matPaginator => {
        return _matPaginator.page.pipe(
          startWith({}),
          switchMap(() => {
            
            return of(array).pipe(
              PageArray(of(_matPaginator.pageIndex), of(_matPaginator.pageSize))
            );
          })
        );
        
      })
    )
  );
}
